import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface RecentSearch {
  locationId: string;
  name: string;
  city: string;
  timestamp: number;
}

const MAX_RECENTS = 5;

interface RecentSearchesState {
  recents: RecentSearch[];
  addRecent: (location: { id: string; name: string; city: string }) => void;
  clearRecents: () => void;
}

export const useRecentSearchesStore = create<RecentSearchesState>()(
  persist(
    (set, get) => ({
      recents: [],

      addRecent: (location) => {
        const { recents } = get();
        const filtered = recents.filter((r) => r.locationId !== location.id);
        const next = [
          { locationId: location.id, name: location.name, city: location.city, timestamp: Date.now() },
          ...filtered,
        ].slice(0, MAX_RECENTS);
        set({ recents: next });
      },

      clearRecents: () => {
        set({ recents: [] });
      },
    }),
    {
      name: 'eve-recent-searches',
    },
  ),
);
